import stockInConfirm from '@/api/stock/stock-in-confirm'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  branch_id: [],
  location_id: [],
  is_confirm: [0],
  dateRange: [
    moment()
      .startOf('M')
      .format('DD-MM-YYYY'),
    moment()
      .endOf('M')
      .format('DD-MM-YYYY')
  ]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_STATUS(state, date) {
    state.is_confirm = date
  },
  SET_LOCATION_ID(state, locationIds) {
    state.location_id = locationIds
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          location_id: context.state.location_id,
          is_confirm_stock:
            context.state.is_confirm.length > 1
              ? ''
              : context.state.is_confirm[0],
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return stockInConfirm.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return stockInConfirm.store(data)
  },
  // Add this action
  confirm(context, data) {
    return stockInConfirm.store(data)
  },
  updateSerial(context, data) {
    return stockInConfirm.updateSerial(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await stockInConfirm.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getSerial(context, id) {
    return stockInConfirm.getSerial(id)
  },
  async checkReceiveMonthDiffMonthTransfer(context, data) {
    return await stockInConfirm.checkReceiveMonthDiffMonthTransfer(data)
  }
}
